"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WS_SIP_ACCOUNT_REGISTRATION = exports.SET_SIP_ACCOUNT = exports.REQUEST_PUT_ACCOUNT = exports.REQUEST_POST_ACCOUNT = exports.REQUEST_GET_FEED_FOR_CALL = exports.REQUEST_DELETE_ACCOUNT = exports.FETCH_SIP_ACCOUNTS = exports.CHECK_SIP_ACCOUNT = void 0;
var CHECK_SIP_ACCOUNT = exports.CHECK_SIP_ACCOUNT = 'CHECK_SIP_ACCOUNT';
var FETCH_SIP_ACCOUNTS = exports.FETCH_SIP_ACCOUNTS = 'FETCH_SIP_ACCOUNTS';
var REQUEST_DELETE_ACCOUNT = exports.REQUEST_DELETE_ACCOUNT = 'REQUEST_DELETE_ACCOUNT';
var REQUEST_GET_FEED_FOR_CALL = exports.REQUEST_GET_FEED_FOR_CALL = 'REQUEST_GET_FEED_FOR_CALL';
var REQUEST_POST_ACCOUNT = exports.REQUEST_POST_ACCOUNT = 'REQUEST_POST_ACCOUNT';
var REQUEST_PUT_ACCOUNT = exports.REQUEST_PUT_ACCOUNT = 'REQUEST_PUT_ACCOUNT';
var SET_SIP_ACCOUNT = exports.SET_SIP_ACCOUNT = 'SET_SIP_ACCOUNT';
var WS_SIP_ACCOUNT_REGISTRATION = exports.WS_SIP_ACCOUNT_REGISTRATION = 'WS_SIP_ACCOUNT_REGISTRATION';